export function avatarFallback(name: string) {
  const splitName = name.split(' ').join('+');

  return `https://ui-avatars.com/api/?name=${splitName}`;
}
